
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1isd1_184ae_93",
  "marker--line": "awsui_marker--line_1isd1_184ae_111",
  "marker--rectangle": "awsui_marker--rectangle_1isd1_184ae_115",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_1isd1_184ae_119",
  "marker--dashed": "awsui_marker--dashed_1isd1_184ae_131"
};
  